<template>
  <NuxtRouteAnnouncer/>
  <NuxtLayout>
    <NuxtPage/>
    <PageUpScrollButton />
  </NuxtLayout>
</template>
